import { Box, Link, Typography } from "@material-ui/core";
import { ReactElement, ReactNode } from "react";
import refundStyles from "./refund-styles";
import { useTranslation } from "react-i18next";
import { OpenInNew } from "@material-ui/icons";
import { LyfeTooltip } from "@lyfegen-platform/react-common";
import { DotIcon } from "../../../../../components/icons/DotIcon";

type HeaderEntryProps = {
	labelKey: string;
	value?: string;
	icon?: ReactNode;
	onClick?: (e: React.SyntheticEvent) => void;
	dot?: boolean;
	tooltip?: boolean;
};

const RefundsHeaderEntry = ({ labelKey, value, onClick, icon, dot = true, tooltip = false }: HeaderEntryProps) => {
	const { t } = useTranslation();
	const { linkText, valueText, iconContainer, newTabLinkIcon, w600, inlineContainer, shrinkable } = refundStyles();
	const Wrapper = ({ children }: { children: ReactElement }) =>
		tooltip && value ? <LyfeTooltip title={value}>{children}</LyfeTooltip> : children;
	return (
		<>
			{icon && <Box className={iconContainer}>{icon}</Box>}
			<Typography className={w600} variant="subtitle1" color="textPrimary">
				{`${t(labelKey)}:`}
			</Typography>
			<Wrapper>
				<Box className={`${inlineContainer} ${tooltip && shrinkable}`}>
					{onClick ? (
						<Link className={`${inlineContainer} ${tooltip && shrinkable}`} onClick={onClick} underline="none">
							<Typography className={`${linkText} ${tooltip && shrinkable}`} variant="subtitle1" color="primary">
								{value}&nbsp;&nbsp;
							</Typography>
							<OpenInNew color="primary" className={newTabLinkIcon} />
						</Link>
					) : (
						<Typography className={`${valueText} ${tooltip && shrinkable}`} variant="subtitle1" color="textPrimary">
							{value}
						</Typography>
					)}
					{dot && <DotIcon />}
				</Box>
			</Wrapper>
		</>
	);
};

export default RefundsHeaderEntry;
